import React, { useState } from 'react';
import TitleConfig from '../Components/titleConfig';
import CardConfig from '../Components/cardsConfig';
import ModalConfigAS1 from '../Components/modalConfigAS1';
const ConfigurationRI = () => {
  const [showDecRules, setShowDecRules] = useState(false);
  const [card, setCard] = useState({
    id: 0,
    title: 'Estado de Cuenta Mensual',
    link: "MODIFICAR CSV"
  });
  const [idConfig, setIdConfig] = useState(null);
  let openModal = idConfig => {
    setShowDecRules(true);
    setIdConfig(idConfig);
  };
  let onCloseModal = () => {
    setShowDecRules(false);
  };

  return (
    <>
     <div className="configHome">
     <TitleConfig title="Renta Inversión" />
      <div className="configHome__container">
        <CardConfig item={card} openModal={openModal} /> 
        <ModalConfigAS1
          close={onCloseModal}
          open={showDecRules}
          idConfig={idConfig}
          title={'Estado de Cuenta'}
          type={'RI'}
          subtitle={'Cargue aquí la información para el EECC de Renta Inversión'}
        />
      </div>
    </div>
    </>
  );
};

export default ConfigurationRI;

